import { Button, FormControl, FormHelperText, Paper, TextField, Theme, WithStyles, createStyles, withStyles } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../modules';
import React, { ChangeEvent, FormEvent, Fragment, MouseEvent } from 'react';
import { faDesktop, faLink, faUser } from '@fortawesome/free-solid-svg-icons';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Typography from '@material-ui/core/Typography';
import { bind } from '../../modules/bindings';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

interface Props extends WithStyles<typeof styles> {
}

const styles = (theme: Theme) => createStyles({
  panel: {
    textAlign: 'center',
    paddingTop: theme.spacing(6),
    borderBottom: '1px solid #ccc',
    width: '100%',
    maxWidth: '40rem',
    margin: `0 auto ${theme.spacing(2)}px auto`,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  text: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(4),
  },
  bindForm: {
    width: '100%',
  },
  buttonGroup1: {
    marginBottom: theme.spacing(2),
    flexDirection: 'column',
    display: 'flex'
  },
  buttonGroup2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignSelf: 'stretch',
    padding: '1rem',
  }
})

type State = {
  error: string
  showForm: boolean
  deviceLabel: string
  showSkip: boolean
}

class BindDevice extends React.Component<Props, State> {
  state = {
    error: "",
    showForm: false,
    deviceLabel: "",
    showSkip: this.props.showSkip || false,
  }

  handleFormVisibility = (visible: boolean) => () => {
    this.setState({
      showForm: visible,
    })
  }

  handleDeviceLabel = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({
      deviceLabel: e.target.value
    })
  }

  handleBind = (e: MouseEvent<HTMLButtonElement> | FormEvent<HTMLFormElement>) => {
    const { bind, complete } = this.props
    const { deviceLabel } = this.state

    bind(deviceLabel).then(() => {
      complete(true)
    }).catch((error: Error) => {
      this.setState({
        error: error.message
      })
    })

    e.preventDefault()
  }

  render() {
    const { bindings, complete, classes, showSkip } = this.props
    const { error, showForm, deviceLabel } = this.state

    return (
      <Fragment>
        {bindings.deviceBindingType !== "HARD_BIND" &&
          <Paper className={classes.panel}>
            <div className="fa-layers fa-fw fa-3x" style={{ color: '#CCC' }}>
              <FontAwesomeIcon icon={faDesktop} transform="left-10" />
              <FontAwesomeIcon icon={faUser} transform="right-10" />
              <FontAwesomeIcon icon={faLink} transform="shrink-4" style={{ color: '#999' }} />
            </div>
            <Typography variant="body1" className={classes.text}>This device is not bound to your user account</Typography>
            {!showForm ?
              <div className={classes.buttonGroup1}>
                <Button variant="contained" color="primary" onClick={this.handleFormVisibility(true)}>Bind This Device</Button>
                {showSkip ?
                  <Button style={{ marginTop: '1rem' }} onClick={() => complete(false)}>Skip</Button>
                  : ""}
              </div>
              : <form onSubmit={this.handleBind} className={classes.bindForm}>

                <FormControl error={error ? true : false}>
                  <TextField
                    autoFocus
                    label="Device Label"
                    value={deviceLabel}
                    onChange={this.handleDeviceLabel}
                    placeholder="e.g. iPhone (Personal)"
                    error={error ? true : false}
                  />
                  {error &&
                    <FormHelperText>{error}</FormHelperText>
                  }
                </FormControl>

                <div className={classes.buttonGroup2}>
                  <Button onClick={this.handleFormVisibility(false)}>Cancel</Button>
                  <Button color="primary" onClick={this.handleBind}>Bind</Button>
                </div>
              </form>
            }
          </Paper>
        }
      </Fragment>
    )
  }
}

const mapStateToProps = ({ bindings }: IStoreState) => ({
  bindings
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      bind
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps> {
  complete: (bound: boolean) => void
  showSkip?: boolean
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(BindDevice));